/* A2 homepage ("Launch" design, Drop #3) · behaviour for sections/a2h-*.liquid.
   - Flip clocks: every [data-a2h-clock][data-target] (digits painted into [data-u] boxes, 1 s tick, clamp at 0).
   - Scroll scenes: --h on the hero ([data-a2h-hero]), --p on the stage ([data-a2h-stage]), --s on every [data-a2h-sc]
     (progress while pinned; for an unpinned scene, how far it has entered the viewport).
   - Sticky bar ([data-a2h-bar]) slides in once the hero clock docks; the hero signup is clickable once revealed.
   - Signup ([data-a2h-form]): Klaviyo client subscription + "SP Drop <n> Signup" event + CRM identify
     (A2Drop.buildPayloadsQuick); with a build or "Not sure" ticked, also "SP Drop <n> Build Picked" + CRM
     (A2Drop.buildPickPayloads). Config: the hero's [data-a2h-config] JSON (custom.sp_drop). Same flow as
     assets/a2-drop-quick.js; never send a `subscriptions` object on the profile (Klaviyo 400s).
   - Build cards ([data-b] on .a2h-card) pre-select that build in the hero signup and scroll there.
   GTM dataLayer only: sp_drop<n>_signup {source: placement}, sp_drop<n>_build_pick. */
(function (w, d) {
  'use strict';
  if (w.A2Home) { return; }
  w.A2Home = true;

  function all(sel, root) { return [].slice.call((root || d).querySelectorAll(sel)); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function clamp01(v) { return Math.min(1, Math.max(0, v)); }
  function readCookie(name) {
    var m = d.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function attribution() {
    var out = {}, st = {};
    try { st = JSON.parse(sessionStorage.getItem('a2_attribution')) || {}; } catch (e) {}
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'].forEach(function (k) { if (st[k]) { out[k] = String(st[k]); } });
    return out;
  }

  var cfg = {};
  function readCfg() { var el = d.querySelector('[data-a2h-config]'); try { cfg = el ? JSON.parse(el.textContent) || {} : {}; } catch (e) { cfg = {}; } }

  /* ---------- clocks ---------- */
  var clocks = [];
  function paint(el, str) {
    if (el.childElementCount !== str.length) { el.innerHTML = str.split('').map(function () { return '<div class="a2h-d"><span></span></div>'; }).join(''); }
    [].forEach.call(el.children, function (box, i) {
      var s = box.firstChild;
      if (s.textContent !== str[i]) { s.textContent = str[i]; box.classList.remove('a2h-flip'); void box.offsetWidth; box.classList.add('a2h-flip'); }
    });
  }
  function tick() {
    var now = Date.now();
    clocks.forEach(function (c) {
      var s = Math.max(0, Math.floor((c.t - now) / 1000));
      var v = { d: pad(Math.floor(s / 86400)), h: pad(Math.floor(s % 86400 / 3600)), m: pad(Math.floor(s % 3600 / 60)), s: pad(s % 60) };
      c.units.forEach(function (u) { paint(u, v[u.getAttribute('data-u')]); });
    });
  }

  /* ---------- scroll ---------- */
  var hero, reveal, bar, stage, scenes = [];
  /* Bottom edge of the theme's sticky header stack (announcement + header), so the pins and the bar sit below it. */
  var lastTop = -1;
  function headerTop() {
    var b = 0;
    all('.shopify-section-group-header-group').forEach(function (el) {
      var cs = w.getComputedStyle(el), r = el.getBoundingClientRect();
      if ((cs.position === 'sticky' || cs.position === 'fixed') && r.top <= 1 && r.bottom > 0 && cs.visibility !== 'hidden' && cs.display !== 'none') { b = Math.max(b, r.bottom); }
    });
    b = Math.round(b);
    if (b !== lastTop) { lastTop = b; d.documentElement.style.setProperty('--a2h-top', b + 'px'); }
    return b;
  }
  function onScroll() {
    var T = headerTop(), vh = w.innerHeight - T; /* the pins start at T, so progress is measured from there */
    if (hero) {
      var hr = hero.getBoundingClientRect(), h = clamp01((T - hr.top) / Math.max(1, hr.height - vh));
      hero.style.setProperty('--h', h.toFixed(4));
      if (reveal && !reveal.classList.contains('a2h-static')) { reveal.classList.toggle('a2h-live-on', h > .5); }
      if (bar) { bar.classList.toggle('a2h-on', h > .44 || hr.bottom < w.innerHeight); }
    }
    if (stage) {
      var r = stage.getBoundingClientRect();
      stage.style.setProperty('--p', clamp01((T - r.top) / Math.max(1, r.height - vh)).toFixed(4));
    }
    scenes.forEach(function (el) {
      var r = el.getBoundingClientRect(), span = r.height - vh;
      var p = span > 20 ? (T - r.top) / span : (w.innerHeight - r.top) / (vh * .8);
      el.style.setProperty('--s', clamp01(p).toFixed(4));
    });
  }
  function goSignup() {
    if (!hero) { return; }
    var top = hero.getBoundingClientRect().top + w.pageYOffset - headerTop();
    w.scrollTo({ top: top + (hero.offsetHeight - (w.innerHeight - headerTop())) * .62, behavior: 'smooth' });
    w.setTimeout(function () { var i = hero.querySelector('[data-a2h-form] input[name=email]'); if (i) { try { i.focus({ preventScroll: true }); } catch (e) {} } }, 900);
  }

  /* ---------- signup ---------- */
  function kPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    });
  }
  function crm(body) {
    if (!cfg.crm || !body) { return; }
    try { fetch(cfg.crm, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).catch(function () {}); } catch (x) {}
  }
  function push(o) { w.dataLayer = w.dataLayer || []; w.dataLayer.push(o); }
  function picked(form) {
    var hs = [], ns = false;
    all('.a2h-chip[aria-pressed=true]', form).forEach(function (c) { if (c.dataset.b === 'ns') { ns = true; } else if (cfg.builds && cfg.builds[c.dataset.b]) { hs.push(c.dataset.b); } });
    return { handles: hs, notSure: ns && !hs.length };
  }
  function markDone() {
    all('[data-a2h-form]').forEach(function (f) { f.classList.add('a2h-done'); });
    var num = cfg.number || 3;
    try { w.localStorage.setItem('a2_drop' + num + '_signed', '1'); } catch (e) {}
    try { d.dispatchEvent(new CustomEvent('a2:drop-signed', { detail: { placement: 'home' } })); } catch (e) {}
  }
  function submit(form) {
    if (form.__busy) { return; }
    var err = form.querySelector('[data-a2h-err]'), btn = form.querySelector('button[type=submit]'), label = btn ? btn.textContent : '';
    var emailEl = form.querySelector('input[name=email]'), hp = form.querySelector('input[name=company_website]');
    var email = (emailEl.value || '').trim(), placement = form.getAttribute('data-placement') || 'home';
    if (err) { err.textContent = ''; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { if (err) { err.textContent = 'Enter a valid email address.'; } emailEl.focus(); return; }
    if (hp && hp.value) { markDone(); return; } /* bots see success, nothing is sent */
    var D = w.A2Drop, num = cfg.number || 3;
    if (!D || !D.buildPayloadsQuick || !cfg.list) { if (err) { err.textContent = "That didn't go through. Please try again in a moment."; } return; }
    var common = { email: email, pageUrl: w.location.href, utm: attribution(), shopifyClientId: readCookie('_shopify_y'),
      ga4ClientId: (function () { var g = readCookie('_ga'); return g ? g.split('.').slice(-2).join('.') : null; })(),
      drop: cfg.drop, dropNumber: num, placement: placement };
    var q = Object.assign({ list: cfg.list, source: (cfg.source || 'SP Drop #' + num + ' early access').replace('home_hero', placement) }, common);
    var pl = D.buildPayloadsQuick(q), pick = picked(form);
    form.__busy = true;
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-busy') || label; }
    kPost('subscriptions', pl.subscription)
      .then(function (r) { if (!r.ok) { throw r; } })
      .then(function () {
        try { kPost('events', pl.event).catch(function () {}); } catch (x) {}
        crm(pl.crm);
        var names = pick.handles.map(function (h) { return cfg.builds[h].name; });
        push({ event: 'sp_drop' + num + '_signup', source: placement, builds: names, build: names.join(' + '), size: 'Not sure', sms_opt_in: false });
        if (pick.handles.length || pick.notSure) {
          var pp = D.buildPickPayloads(Object.assign({}, common, { notSure: pick.notSure,
            builds: pick.handles.map(function (h) { return { handle: h, name: cfg.builds[h].name, colors: cfg.builds[h].colors || [] }; }) }));
          try { kPost('events', pp.event).catch(function () {}); } catch (x) {}
          crm(pp.crm);
          push({ event: 'sp_drop' + num + '_build_pick', source: placement, builds: names, not_sure: pick.notSure });
        }
        markDone();
      })
      .catch(function () {
        form.__busy = false;
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (err) { err.textContent = "That didn't go through. Please try again in a moment."; }
      });
  }
  function ics() {
    var t = Date.parse(cfg.target); if (isNaN(t)) { return; }
    function z(ms) { return new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
    var url = cfg.calendar_url && cfg.calendar_url !== '/' ? cfg.calendar_url : w.location.origin + '/';
    var body = 'BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//A2 Bikes//Drop//EN\r\nBEGIN:VEVENT\r\nUID:a2-drop' + (cfg.number || 3) + '@a2bikes.com\r\nDTSTAMP:' + z(Date.now()) +
      '\r\nDTSTART:' + z(t) + '\r\nDTEND:' + z(t + 3600000) + '\r\nSUMMARY:' + (cfg.calendar_title || 'A2 SP drop early access') + '\r\nURL:' + url + '\r\nEND:VEVENT\r\nEND:VCALENDAR';
    var a = d.createElement('a'); a.href = URL.createObjectURL(new Blob([body], { type: 'text/calendar' })); a.download = 'a2-sp-drop-' + (cfg.number || 3) + '.ics'; d.body.appendChild(a); a.click(); a.remove();
  }

  function init() {
    readCfg();
    hero = d.querySelector('[data-a2h-hero]'); reveal = d.querySelector('[data-a2h-reveal]'); bar = d.querySelector('[data-a2h-bar]');
    stage = d.querySelector('[data-a2h-stage]'); scenes = all('[data-a2h-sc]');
    if (reveal && reveal.classList.contains('a2h-live-on')) { reveal.classList.add('a2h-static'); }
    all('[data-a2h-clock][data-target]').forEach(function (el) {
      var t = Date.parse(el.getAttribute('data-target'));
      if (!isNaN(t)) { clocks.push({ t: t, units: all('[data-u]', el) }); }
    });
    if (clocks.length) { tick(); w.setInterval(tick, 1000); }
    all('.a2h-chip').forEach(function (c) { c.addEventListener('click', function () { c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); }); });
    all('.a2h-card[data-b]').forEach(function (card) {
      card.addEventListener('click', function () {
        all('.a2h-chip').forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.b === card.dataset.b ? 'true' : 'false'); });
        all('.a2h-card').forEach(function (x) { x.setAttribute('aria-pressed', x === card ? 'true' : 'false'); });
        goSignup();
      });
    });
    all('[data-a2h-go]').forEach(function (a) { a.addEventListener('click', function (e) { if (hero) { e.preventDefault(); goSignup(); } }); });
    all('[data-a2h-form]').forEach(function (f) { f.addEventListener('submit', function (e) { e.preventDefault(); submit(f); }); });
    all('[data-a2h-ics]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); ics(); }); });
    w.addEventListener('scroll', onScroll, { passive: true }); w.addEventListener('resize', onScroll); onScroll();
  }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', init); } else { init(); }
})(window, document);
